import styled from 'styled-components';
export const StyledIncomeCertificateDrawer = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  .select-victims {
    align-items: center;
    display: flex;
  }
  .sub_div {
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: auto;
    border-radius: 5px;
  }
  .text {
    font-size: 13px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Medium;
    color: #2b2727;
    margin-bottom: 10px;
  }
  .check_box_container {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }
  .item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 50px;
    color: #2b2727;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    margin-right: 12px;
    min-width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledIncomeCertificateRecap = styled.div`
  background-color: #fff;
  width: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  padding: 24px 0;
  .add-certificate {
    position: relative;
    align-self: self-end;
  }
  .primary-button {
    padding: 10px 16px;
  }
  .add-recap-bloc {
    background-color: #ffffff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    padding: 24px;
    display: grid;
    width: inherit;
  }
  .sub_div {
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: auto;
    background: #f4f4f4 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 16px;
  }
  .text {
    font-size: 13px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Medium;
    color: #2b2727;
    margin-bottom: 10px;
  }
  .check_box_container {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }
  .select-victims {
    align-items: center;
    display: flex;
    width: 100%;
  }
  .submit {
    width: fit-content;
    align-self: flex-end;
    margin: 10px;
  }
  .item {
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 50px;
    color: #2b2727;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    margin-right: 12px;
    min-width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pronounce-add-bloc-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    padding-bottom: 24px;
    margin-top: 10px;
  }
  .accordion-button-icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
    cursor: pointer;
  }
  .field {
    height: 50px;
    width: 20%;
    border-bottom: 1px solid #dddddd;
    margin-right: 24px;
  }
  .item-container {
    display: flex;
    align-items: flex-end;
    width: 100%;
    justify-content: flex-start;
  }
`;
export const Wrapper = styled.div`
  .icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  background-color: #fff;
  width: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 1px 3px #0000001f;
  padding: 24px 0;
  border-radius: 4px;
  .content {
    margin: 0 auto;
    width: 96%;
  }
  .pronounce-add-bloc-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
    padding-bottom: 24px;
  }
  .sub_div {
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: auto;
    background: #f4f4f4 0% 0% no-repeat padding-box;
    border-radius: 5px;
    padding: 16px;
  }

  .text {
    font-size: 13px;
    letter-spacing: 0;
    font-family: Roboto;
    font-weight: Medium;
    color: #2b2727;
    margin-bottom: 10px;
  }
  .check_box_container {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }
  .select-victims {
    align-items: center;
    display: flex;
  }
  .submit {
    width: fit-content;
    align-self: flex-end;
    margin: 10px;
  }
`;

export const JudgementAddFormContainer = styled.div`
  .infoBloc {
    padding: 10px 0;
    margin: 10px -10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
  }
  .MuiInputLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #00000061;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .field {
    margin: 0 10px;
    width: 40%;
    font-size: 13px;
    color: #2b2727;
    font-weight: bold;
  }
  .upload-document {
    margin: 25px 0 16px 0;
  }
  .upload-doc-title {
    font-size: 14px;
    font-weight: bold;
    color: #2b2727;
  }
  .upload-document-button {
    margin-top: 16px;
    font-weight: normal;
    font-size: 14px;
    padding: 10px;
    min-width: 220px;
  }
  .cloud-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  .submit-add-form {
    padding: 24px;
    display: flex;
  }
  #primary-button-style {
    margin-right: 16px;
    height: 36px;
  }
  #secondary-button-style {
    height: 36px;
  }

  .consult {
    cursor: pointer;
  }
`;

export const ExpertiseFormWrapper = styled.div`
  margin: 10px auto;
  .expertise-content-wrapper {
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px 1px 3px #0000001f;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 24px;
  }
  .MuiInputLabel-root {
    font-size: 13px;
  }
  .MuiInputLabel-shrink {
    color: #8b8b8b;
  }
  .MuiFormLabel-root.Mui-focused {
    color: rgba(9, 122, 194, 1);
  }
  .field {
    width: 20%;
    font-size: 13px;
    color: #2b2727;
    font-weight: bold;
  }
  .expertise-form {
    margin: 25px 0 16px 0;
    display: flex;
    align-items: center;
  }
  .expertise {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .add-expertise-button {
    width: 215px;
    height: 24px;
    font-size: 14px;
    color: #0075c9;
    text-transform: uppercase;
  }
  .add-icon {
    width: 14px;
    height: 14px;
    fill: #1175c9;
    margin-right: 8px;
  }
  .checkbox-section {
    padding: 0 10px;
  }
  .checkbox-wrapper {
    margin: 16px 0 24px 0;
    align-items: center;
  }
  .victim-wrapper {
    margin-top: 30px;
    display: flex;
  }
  .checkbox-bloc {
    padding: 0 20px;
    background-color: #fff;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    height: 36px;
    color: #2b2727;
    display: flex;
    justify-content: space-between;
    margin: 0 8px;
  }
  .checkbox {
    width: 18px;
    height: 18px;
  }
  .MuiFormControlLabel-label {
    font-weight: bold;
    font-size: 13px;
    margin-left: 10px;
  }
  .wrapper-expert {
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: -15px;
  }
`;

export const Forms = styled.div`
  position: relative;
  .add-document {
    position: absolute;
    right: 0;
    top: -57px;
  }
  .icon {
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  .add-judgement-add-pronoucing-style {
    padding: 10px 16px;
  }
`;

export const ExpertiseFormsWrapper = styled.main`
  .expertises {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .expertise-forms-title {
    font-size: 18px;
    font-weight: bold;
    color: #2b2727;
  }
`;
